import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { exists } from '~/utils'

import { useBrandAccountId } from './useBrandAccountId'

const document = graphql(`
  mutation StrategyMemoListPage_CreateStrategyMemo($brandAccountId: String!) {
    createCustomerStrategyMemo(
      brandAccountId: $brandAccountId
      title: "無名の戦略メモ"
    ) {
      id
    }
  }
`)

export const useCreateStrategyMemoMutation = (
  options: MutationOptions<string, void> = {},
) => {
  const { t } = useTranslation()
  const graphQLRequest = useGraphQLRequest()
  const brandAccountId = useBrandAccountId()

  return useMutation({
    mutationFn: async () => {
      const result = await graphQLRequest({
        document,
        variables: { brandAccountId, title: t('untitled') },
      })
      const strategyMemoId = result.createCustomerStrategyMemo?.id
      if (!exists(strategyMemoId)) {
        throw new Error(t('creation_failed_5'))
      }

      return strategyMemoId
    },
    ...options,
  })
}
